import React from 'react';
import {
  List,
  Typography
} from '@mui/material';
import { CustomGroup } from '../../api/models/CustomGroup';
import CustomGroupsRow from '../CustomGroupsRow/CustomGroupsRow';

interface CustomGroupsTableProps {
  customGroups: CustomGroup[];
  isLoading: boolean;
  onDeleteGroup: (groupName: string) => void;
  onEditGroup: (groupName: string) => void;
}

const CustomGroupsTable: React.FC<CustomGroupsTableProps> = ({
  customGroups,
  isLoading,
  onDeleteGroup,
  onEditGroup,
}) => {
  if (customGroups.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', py: 4 }}>
        No custom groups found. Create your first group to get started.
      </Typography>
    );
  }

  return (
    <List>
      {customGroups.map((group, index) => (
        <CustomGroupsRow
          key={`${group.groupName}-${index}`}
          group={group}
          index={index}
          totalGroups={customGroups.length}
          isLoading={isLoading}
          onDeleteGroup={onDeleteGroup}
          onEditGroup={onEditGroup}
        />
      ))}
    </List>
  );
};

export default CustomGroupsTable;